import { ETxnSpeed } from "../ETxnSpeed";

/**
 * Returns an array of available transaction speeds for a company based on feature flags and/or permissions.
 * Prefer company permissions as input. Feature flags are available for backwards compatibility.
 *
 * @param  params - The configuration object.
 * @param params.reserveEnabled - Whether reserve-based speeds are enabled.
 * @param params.zeroDayNoReserveEnabled - Explicitly enable zero day no reserve speed.
 * @param params.oneDayNoReserveEnabled - Explicitly enable one day no reserve speed.
 * @param params.fourDayEnabled - Explicitly enable four day speed.
 * @param params.featureFlags={} - DEPRECATED: Feature flags that may enable additional speeds.
 * @returns Array of available transaction speed options.
 */
export const getSpeedsForCompany = ({
  featureFlags = {},
  fourDayEnabled,
  instantPayEnabled,
  oneDayNoReserveEnabled,
  reserveEnabled,
  zeroDayNoReserveEnabled,
}: {
  featureFlags?: Record<string, boolean>;
  fourDayEnabled?: boolean;
  instantPayEnabled: boolean;
  oneDayNoReserveEnabled?: boolean;
  reserveEnabled: boolean;
  zeroDayNoReserveEnabled?: boolean;
}) => {
  const isZeroDayNoReserveEnabled =
    zeroDayNoReserveEnabled ?? featureFlags["enable-zero-day-no-reserve-speed"];
  const isOneDayNoReserveEnabled =
    oneDayNoReserveEnabled ?? featureFlags["enable-one-day-no-reserve-speed"];
  const isFourDayEnabled =
    fourDayEnabled ?? featureFlags["enable-four-day-speed"];
  return [
    ...(instantPayEnabled
      ? [{ value: ETxnSpeed.INSTANT, label: "Instant", showInDropdown: true }]
      : []),
    ...(reserveEnabled
      ? [
          {
            value: ETxnSpeed.ZERO_DAY,
            label: "Zero day",
            showInDropdown: true,
          },
          { value: ETxnSpeed.ONE_DAY, label: "One day", showInDropdown: true },
        ]
      : []),
    ...(isZeroDayNoReserveEnabled
      ? [
          {
            value: ETxnSpeed.ZERO_DAY_NO_RESERVE,
            label: "Zero day no reserve",
            showInDropdown: true,
          },
        ]
      : []),
    ...(isOneDayNoReserveEnabled
      ? [
          {
            value: ETxnSpeed.ONE_DAY_NO_RESERVE,
            label: "One day no reserve",
            showInDropdown: true,
          },
        ]
      : []),
    {
      value: ETxnSpeed.TWO_DAY,
      label: "Two day",
      showInDropdown: true,
    },
    ...(isFourDayEnabled
      ? [{ value: ETxnSpeed.FOUR_DAY, label: "Four day", showInDropdown: true }]
      : []),
  ];
};
